import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../actions/index';
import * as _ from 'lodash'
import classNames from "classnames";
import {getData, LOGIN} from "../util/storage";
import {getSearchQuery, isEmpty} from "../util/utility";
import {checkIfFollowingListAvailable} from "../util/follow_util"
import ContentLoader from "react-content-loader"
import {getEncryptedIdForBroadcaster} from "../util/broadcast_util"
//image
import icon_following from "../assets/images/icon_following.png"
import icon_following_active from "../assets/images/icon-following-active.png"
import icon_users from "../assets/images/icon_users@2x.png"
import online from "../assets/images/icon-vuepay-blue@2x.png"
import icon_credit_card from "../assets/images/icon_credit_card.png"

class Following extends Component {

    constructor(props) {
        super(props)

        this.state = {
            followingList: []
        }
    }

    /**
     * @function is invoked immediately after a component is mounted. Initialization that requires DOM nodes should go here.
     * If you need to load data from a remote endpoint, this is a good place to instantiate the network request.
     */
    componentDidMount() {
        //every time the dashboard is loaded we check if the user api_token and token is available
        //it the api_token and token is available we do hit getUserDetails Webservice
        getData(LOGIN)
            .then((data) => {
                if (!isEmpty(data)) {
                    this.props.getFollowingList(data.token, data.api_token, getSearchQuery(), "")
                }
            })

    }

    /**
     * @function This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {

        getData(LOGIN)
            .then((data) => {
                if (!isEmpty(data)) {
                    let x = "Popular";
                    x = document.getElementById("inputGroupSelect01") && document.getElementById("inputGroupSelect01").value;

                    const filter = x === "Popular" ? "popularity" : x === "Trending" ? "most_views" : "most_recent"
                    if (nextProps.following.hasOwnProperty("performSearch") && nextProps.following.performSearch) {
                        this.props.getFollowingList(data.token, data.api_token, getSearchQuery(), filter)
                        this.props.setSearchFollowingState(false)
                    }

                }
            })

        if (checkIfFollowingListAvailable(nextProps)) {
            this.setState({
                followingList: nextProps.following.followingList.data.data
            })
        }

    }

    onClickOfFollowingBroadcaster = (broadcaster_id) => (e) => {
        this.props.history.push(`/following/${getEncryptedIdForBroadcaster(broadcaster_id)}`);
    }

    sortByOptionSelected = () => {
        var x = document.getElementById("inputGroupSelect01").value;

        getData(LOGIN)
            .then((data) => {
                if (!isEmpty(data)) {
                    const filter = x === "Popular" ? "popularity" : x === "Trending" ? "most_views" : "most_recent"
                    this.props.getFollowingList(data.token, data.api_token, getSearchQuery(), filter)
                }
            })
    }


    render() {

        const broadcastContainerParent = classNames("row", {
            "broadcast-container-parent": !this.props.children
        })
        return (
            <div>
                <main role="main" className="">
                    <div className={broadcastContainerParent}>
                        <div className="broadcast-container other-middle-container"
                             style={this.props.children ? {marginTop: 10} : {}}>
                            <div className="title-container">

                                <div>
                                    <h4>Following
                                        {this.state.followingList.length > 0 &&
                                        <span> ({this.state.followingList.length})</span>}
                                    </h4>
                                </div>

                                <div>
                                    <span>Sort by</span>
                                    <select className="custom-select" id="inputGroupSelect01"
                                            onChange={this.sortByOptionSelected}>
                                        <option selected>Popular</option>
                                        {/*<option value="1">Popular</option>*/}
                                        <option value="2">Trending</option>
                                        <option value="3">Recent activity</option>
                                    </select>
                                </div>
                            </div>
                            {this.props.following.isFetching && this.state.followingList.length === 0 &&
                            <ContentLoader
                                height={240}
                                speed={1}
                                primaryColor="#f3f3f3"
                                secondaryColor="#ecebeb">

                                <rect x="10" y="20" rx="4" ry="4" width="70" height="40"/>
                                <rect x="10" y="65" rx="4" ry="4" width="70" height="5"/>
                                <rect x="10" y="75" rx="4" ry="4" width="70" height="5"/>

                                <rect x="90" y="20" rx="4" ry="4" width="70" height="40"/>
                                <rect x="90" y="65" rx="4" ry="4" width="70" height="5"/>
                                <rect x="90" y="75" rx="4" ry="4" width="70" height="5"/>

                                <rect x="170" y="20" rx="4" ry="4" width="70" height="40"/>
                                <rect x="170" y="65" rx="4" ry="4" width="70" height="5"/>
                                <rect x="170" y="75" rx="4" ry="4" width="70" height="5"/>

                            </ContentLoader>
                            }
                            <div className="row">

                                {
                                    this.state.followingList.length > 0 && _.map(this.state.followingList, (data) => {

                                        return <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4"
                                                    style={{cursor: 'pointer'}} key={data.id}
                                                    onClick={this.onClickOfFollowingBroadcaster(data.id)}>

                                            <div className="broadcast-wrapper followers-wrapper">
                                                <div className="followers-img">
                                                    <img src={data.profile_pic} alt="followers"/>
                                                </div>
                                                <div className="followers-icon"><img src={icon_following_active}
                                                                                     alt="Followers"/></div>
                                                <div className="broadcast-content">
                                                    <p className="font-weight-bold">{data.username}
                                                        {
                                                            data.status === "online" &&
                                                            <span className="online"><img src={online}
                                                                                          alt="Online"/></span>

                                                        }
                                                    </p>
                                                    {
                                                        data.status === "online" && data.broadcast.length > 0 ?
                                                            <p className="small hits">
                                                                {data.broadcast.length > 0 && data.broadcast[0].broadcast_type === "paid" &&
                                                                <a href="" title="Credit Card"><img
                                                                    src={icon_credit_card} alt="Credit Card"/></a>}
                                                                <a href="" title="Following"><img src={icon_following}
                                                                                                  alt="Following"/></a>
                                                                <a href="" title="Users"><img src={icon_users}
                                                                                              alt="Users"/></a>
                                                                <span>{data.followers_count}</span>
                                                            </p>
                                                            :
                                                            <p className="small hits">
                                                                <span>{data.status === "online" && data.broadcast.length === 0 ? "Online" : "Offline"}</span>
                                                            </p>
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    })
                                }


                            </div>
                            {
                                this.state.followingList && this.state.followingList.length == 0 &&
                                <div style={{textAlign: 'center', marginTop: '100px'}}>
                                    <p>Sorry, you aren't following anyone at the moment. Maybe follow a broadcaster?</p>
                                </div>
                            }
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

function mapStateToProps(state, ownParams) {
    return {
        account_management: state.account_management,
        device: state.device.payload,
        following: state.following
    };
}

export default connect(mapStateToProps, actions)(Following);